/**
 * Footer diagnostics: which of the two load-balanced servers answered, and
 * which build is running.
 *
 * Both come from the backend (api/AppInfo/GetInfo) in one call, so bumping
 * <Version> in WesReact.csproj and rebuilding the backend is enough to update
 * the footer - the SPA does not need rebuilding. Cached for the life of the
 * page: one request, however many components ask for it.
 */
import { axiosInstance } from "../axios/axiosInstance";

const EMPTY = { node: "", version: "" };

let currentInfo = EMPTY;
let inFlight = null;

/** @returns {{node: string, version: string}} empty strings until fetched */
export const getAppInfo = () => currentInfo;

/**
 * Fetch the info once. Concurrent callers share the same request, and a failure
 * resolves to empty strings so the caller can simply render nothing.
 *
 * @returns {Promise<{node: string, version: string}>}
 */
export const fetchAppInfo = async () => {
  if (currentInfo !== EMPTY) return currentInfo;

  if (!inFlight) {
    inFlight = axiosInstance
      .get("AppInfo/GetInfo")
      .then((res) => {
        // The response interceptor returns false for some responses, so guard.
        const data = typeof res?.data === "object" && res.data !== null ? res.data : {};
        currentInfo = {
          node: String(data.node ?? "").trim(),
          version: String(data.version ?? "").trim(),
        };
        return currentInfo;
      })
      .catch(() => EMPTY)
      .finally(() => {
        inFlight = null;
      });
  }

  return inFlight;
};
